import { defineNuxtPlugin } from '#app';
import { detectIsMobile } from '~/utils/isMobile';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('isMobile', detectIsMobile());
});
